import { render, staticRenderFns } from "./PlanUpgradeModalTab.vue?vue&type=template&id=e631b2a0&scoped=true&"
import script from "./PlanUpgradeModalTab.vue?vue&type=script&lang=js&"
export * from "./PlanUpgradeModalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e631b2a0",
  null
  
)

export default component.exports